import { StateFilterData } from '../forms/address/types';
import LevelFirstForm from './LevelFirstForm';

window.tnew.page.initialize = function initialize({ stateFilterData }: { stateFilterData: StateFilterData }) {
  const $form = document.querySelector('#tn-level-first-form') as HTMLFormElement;

  new LevelFirstForm($form, stateFilterData);
};
